/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name bepozperiodselect
 * @description Date picker to replicate the one found on the bepoz Back Office reports.
 */
angular.module('mercury.directives.bepozperiodselect', [])
.directive('bepozperiodselect', ["reporttime", "$state", function(reporttime, $state) {
  return {
    restrict: 'A',
    templateUrl: 'directives/bepozperiodselect/bepozperiodselect.tpl.html',
    scope: true,
    link: function(scope) {
      scope.period = reporttime.reportType();
      scope.periods = [
        {value: 'day', label: 'Current Day'},
        {value: 'week', label: 'Current Week'},
        {value: 'month', label: 'Current Month'},
        {value: 'year', label: 'Current Year'},
        {value: 'yesterday', label: 'Yesterday'},
        {value: 'custom', label: 'Custom'}
      ];

      scope.customStart = reporttime.start();
      scope.customEnd = reporttime.end();

      scope.apply = function() {
        if (scope.period == 'custom') {
          $state.go($state.current.name, {report: JSON.stringify({type: scope.period, start: scope.customStart, end: scope.customEnd}), store: scope.activeStoreId});
        } else {
          $state.go($state.current.name, {report: JSON.stringify({type: scope.period}), store: scope.activeStoreId});
        }
      };
    }
  };
}]);
